/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA
 *
 */
import { writable, get } from 'svelte/store';
import { getUser as getUserTokenData } from '@/services/authService';
import _ from 'lodash';

export const user = createAuthStore();

function createAuthStore() {
    const userStore = writable({});
    const { subscribe, set, update } = userStore;

    return {
        get() {
            return get(user);
        },
        subscribe,
        set,
        update,
        updateInfo() {
            this.updateTokenData();
        },
        updateTokenData() {
            try {
                const { userId, name, roles, email, tenantId, hierarchy } = getUserTokenData();
                update(s => ({
                    ...s,
                    userId,
                    name,
                    roles: _.uniq(roles.filter(role => role !== '')),
                    email,
                    tenantId,
                    hierarchy
                }));
            } catch (err) {
                set(null);
            }
        }
    };
}
